export default __webpack_public_path__ + "static/media/96_mobile.b993939f.jpg";